import {SELECT_MEDIA, DESELECT_MEDIA, SELECT_ALL_MEDIA, DESELECT_ALL_MEDIA} from '../constants/actionTypes';

export const selectedURLs = (state = [], action) => {
    switch(action.type) {
        case SELECT_MEDIA:
            return [...state, action.url];
        
        case DESELECT_MEDIA:
            // In the case where we have two of the same urls in an array we are removing only the first one found.
            return removeSingle(state, action.url);
        
        case SELECT_ALL_MEDIA:
            return [...state, ...action.urls];

        case DESELECT_ALL_MEDIA:
            return removeMany(state, action.urls);

        default:
            return state;
    }
};

const removeSingle = (array, url) => {
    return [...array.slice(0, array.indexOf(url)), ...array.slice(array.indexOf(url) + 1)];
};

const removeMany = (array, urlArray) => {
    urlArray.forEach(url => array = removeSingle(array,  url));
    return [...array];
};



// WEBPACK FOOTER //
// ./src/reducers/selectedURLs.js